import React from "react";

export enum FormatType {
  DMY_HMS = "dd/MM/yyyy HH:mm:ss",
  DMMMYYYY_HMS = "dd MMM yyyy HH:mm:ss",
  YMD_HMS = "yyyy/MM/dd HH:mm:ss",
  YMMMDD_HMS = "yyyy MMM dd HH:mm:ss",
  MDY_HMS = "MM/dd/yyyy HH:mm:ss",
  MMMDDYYYY_HMS = "MMM dd yyyy HH:mm:ss",
}

const FORMAT_PREVIEWS: { label: FormatType; formatString: string }[] = [
  { label: FormatType.DMY_HMS, formatString: "dd/MM/yyyy HH:mm:ss" },
  { label: FormatType.DMMMYYYY_HMS, formatString: "dd MMM yyyy HH:mm:ss" },
  { label: FormatType.YMD_HMS, formatString: "yyyy/MM/dd HH:mm:ss" },
  { label: FormatType.YMMMDD_HMS, formatString: "yyyy MMM dd HH:mm:ss" },
  { label: FormatType.MDY_HMS, formatString: "MM/dd/yyyy HH:mm:ss" },
  { label: FormatType.MMMDDYYYY_HMS, formatString: "MMM dd yyyy HH:mm:ss" },
];

type Props = {
  selectedFormat?: FormatType;
  onChange?: (format: FormatType) => void;
};

const DateFormatSelector: React.FC<Props> = ({
  selectedFormat = FormatType.DMY_HMS,
  onChange,
}) => {
  return (
    <div className="w-full max-w-md mx-auto">
      <label className="block mb-2 text-sm font-medium text-gray-700">Date Format</label>
      <select
        className="text-xs sm:text-sm px-2 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 w-auto max-w-full"
        value={selectedFormat}
        onChange={(e) => onChange?.(e.target.value as FormatType)}
      >
        {FORMAT_PREVIEWS.map((item) => (
          <option key={item.label} value={item.label}>
            {item.label}
          </option>
        ))}
      </select>
    </div>
  );
};
export default DateFormatSelector;

export const formatUTCDate = (
  dateInput: Date | string
): {
  day: string;
  month: string;
  year: string;
  hours: string;
  minutes: string;
  seconds: string;
} => {
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);

  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = String(date.getUTCFullYear());
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const seconds = String(date.getUTCSeconds()).padStart(2, "0");

  return { day, month, year, hours, minutes, seconds };
};

export const formatCustomDateTime = (
  dateObj: Date | string,
  format: FormatType
): string => {
  const MONTH_NAMES = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const { day, month, year, hours, minutes, seconds } = formatUTCDate(dateObj);
  const monthIndex = parseInt(month, 10) - 1;
  const MMM = MONTH_NAMES[monthIndex];
  return format
    .replace(/yyyy/g, year)
    .replace(/MMM/g, MMM)
    .replace(/MM/g, month)
    .replace(/dd/g, day)
    .replace(/HH/g, hours)
    .replace(/mm/g, minutes)
    .replace(/ss/g, seconds);
};
